(function () {
  "use strict";

  class ProductVariantCountComponent extends HTMLElement {
    constructor() {
      super();
    }

    static get observedAttributes() {
      return ["product"];
    }

    get product() {
      return this._product;
    }

    set product(value) {
      this._product = value;
      this.render();
    }

    connectedCallback() {
      if (this._product) {
        this.render();
      }
    }

    render() {
      if (this?._product?.variants?.length) {
        this.innerHTML = `
        <p class="product-variant-count text-subdued text-sm">
          ${this?._product?.variants?.length} Farben verfügbar
        </p>
      `;
      }
    }
  }

  customElements.define(
    "rcc-product-variant-count",
    ProductVariantCountComponent
  );
})();
